module.exports = __webpack_public_path__ + "img/search.281d015e.svg";